module.exports = __webpack_public_path__ + "static/media/scanner-keyboard.e71753fe.svg";